<div class="list-page kapea" style="max-width: 1300px">
  <app-asiakas-otsikko otsikko="Selaa toimittajia" [asiakas]="asiakas()"></app-asiakas-otsikko>

  <form novalidate class="ylaosan-kontrollit">
    <div class="hakukontrollit">
      <mat-form-field>
        <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
        <mat-label>Etsi (nimi, y-tunnus, numero, IBAN)</mat-label>
        <input type="text" [formField]="lomake.haku" matInput />
      </mat-form-field>

      <mat-checkbox [formField]="lomake.naytaPoistetut">Näytä poistetut</mat-checkbox>
    </div>
  </form>

  <div style="position: relative">
    <mat-table matSort [dataSource]="dataSource" [matSortDisableClear]="true" style="min-height: 94px">
      <ng-container matColumnDef="numero">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 90px">Nro</mat-header-cell>
        <mat-cell *matCellDef="let row" class="mono" style="max-width: 90px">{{ row.numero ?? '–' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="nimi">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Nimi</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.nimi || '–' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="ytunnus">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 120px">Y-tunnus</mat-header-cell>
        <mat-cell *matCellDef="let row" class="mono" style="max-width: 120px">{{ row.ytunnus || '–' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="iban">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 260px">IBAN</mat-header-cell>
        <mat-cell *matCellDef="let row" class="mono" style="max-width: 260px">
          {{ oletusIban(row) || '–' }}
          @if (ibanienMaara(row) > 1) {
            <span class="lisa-iban-badge">+{{ ibanienMaara(row) - 1 }}</span>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="paivitetty">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 140px">Päivitetty</mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 140px">{{ row.paivitetty?.toDate() | date: 'dd.MM.yyyy' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="tila">
        <mat-header-cell *matHeaderCellDef style="max-width: 100px">Tila</mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 100px" [class.red-text]="row.poistettu">{{ row.poistettu ? 'Poistettu' : 'Aktiivinen' }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row (click)="avaa(row)" *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    @if ((rivienMaaraObservable | async) === 0 && (lataaObservable | async) === false) {
      <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
        <div style="width: 100%; padding-top: 40px; text-align: center; color: #888">Ei toimittajia.</div>
      </div>
    }
  </div>

  <mat-paginator [length]="rivienMaaraObservable | async" [pageSize]="20" [pageSizeOptions]="[20, 50, 200]"></mat-paginator>
</div>
